import {
  BankOutlined,
  FileTextOutlined,
  UserOutlined,
  IdcardOutlined,
} from "@ant-design/icons";
export const SidebarItems = [
  {
    key: 1,
    icon: <UserOutlined />,
    label: "Account",
    to: "/accounts",
    paths: ["accounts", "create-account"],
    name: "Account list",
    level: 1,
  },
  {
    key: 2,
    icon: <IdcardOutlined />,
    label: "Role",
    to: "/roles",
    paths: ["roles", "create-role"],
    name: "Role list",
    level: 1,
  },
  {
    key: 3,
    icon: <BankOutlined />,
    label: "Unit",
    to: "/units",
    paths: ["units", "create-unit"],
    name: "Unit list",
    level: 1,
  },
  {
    key: 4,
    icon: <FileTextOutlined />,
    label: "Faculty Profile",
    to: "/profiles",
    paths: ["profiles", "create-profile"],
    name: "Faculty profile list",
    level: 1,
  },
];
